import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_USER_CENTER = '/user';

export const UserCenterRoutesConfig: { [key: string]: RouteConfiguration } = {
  Index: {
    path: PATH_USER_CENTER,
    generatePath: () => PATH_USER_CENTER,
  },
};

const LoadableUserCenterContainer: LoadableComponent<any> = loadable(
  async () =>
    import('./screens').then(module => module.UserCenter),
  {
    fallback: <QueryLoadingAbsolute />,
  },
);

export function UserCenterRoutes() {
  return (
    <Route
      path={UserCenterRoutesConfig.Index.path}
      exact={true}
      component={LoadableUserCenterContainer}
    />
  );
}
